import { IPopUpSectionData } from "@pageBuilder/typings";
import { PopUpSectionRenderer } from "../pop-up/pop-up-section-renderer";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { MeshCascadeRenderer } from "src/mesh/renderers/cascade-renderers/mesh-cascade-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class PopUpSectionCascadeRenderer extends CascadeRendererBase<IPopUpSectionData> {

    protected readonly renderer: PopUpSectionRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new PopUpSectionRenderer(this.renderingCommonContext);
    }

    public override createByCascade(data: IPopUpSectionData): HTMLElement {
        const element = this.renderer.createNew();
        this.renderer.render(element, data);

        const sectionContent = element.querySelector(":scope > .content") as HTMLElement;

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const meshData = data.content.mesh!;
        const meshRenderer = CascadeRendererFactory.create("Mesh", this.renderingCommonContext) as MeshCascadeRenderer;

        const meshElement = meshRenderer.createByCascade(meshData);

        sectionContent.append(meshElement);
        return element;
    }

    public override getDataByCascade(element: HTMLElement): IPopUpSectionData {
        const data = this.renderer.getData(element) as IPopUpSectionData;

        const meshElement = element.querySelector(":scope > .content > [data-mesh]") as HTMLElement;
        const meshRenderer = CascadeRendererFactory.create("Mesh", this.renderingCommonContext) as MeshCascadeRenderer;
        data.content.mesh = meshRenderer.getDataByCascade(meshElement);

        return data;
    }

}
